// ==========================
// Password toggle handlers
// ==========================
const togglePasswordVisibility = (toggleId, inputId) => {
    const toggle = document.querySelector(`#${toggleId}`);
    const input = document.querySelector(`#${inputId}`);
    if (toggle && input) {
        toggle.addEventListener('click', function () {
            const type = input.getAttribute('type') === 'password' ? 'text' : 'password';
            input.setAttribute('type', type);
            this.classList.toggle('fa-eye-slash');
        });
    }
};

togglePasswordVisibility('togglePassword', 'password');
togglePasswordVisibility('toggleConfirmPassword', 'confirm_password');

// ==========================
// Helpers
// ==========================
function validateEmail(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
}

function validatePhone(phone, countryCode = '+992') {
    const cleaned = phone.replace(/[\s\-\(\)]/g, '');
    return countryCode === '+992' && /^[0-9]{9}$/.test(cleaned);
}

function showValidationError(input, message) {
    const container = input.closest('.input-group');
    const errorFeedback = container?.querySelector('.invalid-feedback');
    if (errorFeedback) {
        errorFeedback.textContent = message;
        input.classList.add('is-invalid');
    }
}

function clearValidationError(input) {
    const container = input.closest('.input-group');
    const errorFeedback = container?.querySelector('.invalid-feedback');
    if (errorFeedback) {
        errorFeedback.textContent = '';
        input.classList.remove('is-invalid');
    }
}

function toggleButton(isSubmitting, button) {
    if (!button.dataset.originalText) {
        button.dataset.originalText = button.textContent.replace('...', '').trim();
    }
    button.textContent = isSubmitting ? button.dataset.originalText + '...' : button.dataset.originalText;
    button.disabled = isSubmitting;
}

function attachLiveInputClear(form, fields) {
    fields.forEach(fieldName => {
        const input = form.querySelector(`input[name="${fieldName}"]`);
        input?.addEventListener('input', () => clearValidationError(input));
    });
}

// ==========================
// Generic Countdown Timer
// ==========================
let timers = {};

function startCountdown(buttonId, resendAvailableAt, serverTime) {
    const button = document.getElementById(buttonId);
    if (!button) return;
    
    button.disabled = true;
    const originalText = button.dataset.originalText || button.textContent;
    
    if (timers[buttonId]) clearInterval(timers[buttonId]);
    
    const localTime = Math.floor(Date.now() / 1000);
    const timeDiff = localTime - serverTime;
    
    // Get localized seconds suffix from button data attribute (default to 's' if not available)
    const secondsSuffix = button.dataset.secondsSuffix || 's';
    
    function updateCountdown() {
        const currentLocalTime = Math.floor(Date.now() / 1000);
        const timeLeft = Math.max(0, resendAvailableAt - (currentLocalTime - timeDiff));
        
        if (timeLeft > 0) {
            button.textContent = `${originalText} (${timeLeft}${secondsSuffix})`;
        } else {
            clearInterval(timers[buttonId]);
            button.disabled = false;
            button.textContent = originalText;
        }
    }
    
    updateCountdown();
    timers[buttonId] = setInterval(updateCountdown, 1000);
}

// ==========================
// Generic SMS Handler
// ==========================
async function handleSmsFlow(config) {
    const {
        form, phoneInput, codeInput, codeSection,
        sendButton, verifyButton, resendButton,
        errorElement, sendRoute, verifyRoute, resendRoute,
        type, additionalData = {}
    } = config;
    
    const baseUrl = document.querySelector('meta[name="base-url"]').getAttribute('content');
    const csrfToken = document.querySelector('meta[name="csrf-token"]').getAttribute('content');
    const appLocale = document.documentElement.lang || 'ru';
    let currentPhone = '';
    
    // Send SMS
    sendButton?.addEventListener('click', async (e) => {
        e.preventDefault();
        
        if (!phoneInput.value.trim()) {
            showValidationError(phoneInput, window.validationMessages?.phoneRequired || 'Phone number is required.');
            return;
        }
        
        // Get country code from selector if available
        const countryCodeSelect = document.querySelector('#country-code-select');
        const countryCode = countryCodeSelect ? countryCodeSelect.value : '+992';
        
        if (!validatePhone(phoneInput.value, countryCode)) {
            showValidationError(phoneInput, window.validationMessages?.phoneInvalid || `Enter a valid phone number (9 digits for ${countryCode}).`);
            return;
        }
        
        toggleButton(true, sendButton);
        errorElement.textContent = '';
        
        try {
            const formData = new FormData();
            
            // Get country code and combine with phone number
            const countryCodeSelect = document.querySelector('#country-code-select');
            const countryCode = countryCodeSelect ? countryCodeSelect.value : '+992';
            const fullPhone = countryCode + phoneInput.value.replace(/[\s\-\(\)]/g, '');
            
            formData.append('phone', fullPhone);
            formData.append('type', type);
            formData.append('lang', appLocale);
            Object.entries(additionalData()).forEach(([key, val]) => formData.append(key, val));
            
            const response = await fetch(`${baseUrl}${sendRoute}`, {
                method: 'POST',
                headers: { 'X-CSRF-TOKEN': csrfToken },
                body: formData
            });
            
            const data = await response.json();
            
            if (!response.ok || !data.status) {
                errorElement.textContent = data.message || 'Failed to send SMS';
                return;
            }
            
            currentPhone = fullPhone;
            phoneInput.disabled = true;
            if (countryCodeSelect) countryCodeSelect.disabled = true;
            sendButton.style.display = 'none';
            codeSection.style.display = 'block';
            verifyButton.style.display = 'block';
            resendButton.style.display = 'block';
            codeInput.focus();
            
            if (data.resend_available_at && data.server_time) {
                startCountdown(resendButton.id, data.resend_available_at, data.server_time);
            }
        } catch (error) {
            console.error('SMS send error:', error);
            errorElement.textContent = 'A system error occurred. Please try again.';
        } finally {
            toggleButton(false, sendButton);
        }
    });
    
    // Verify SMS
    verifyButton?.addEventListener('click', async (e) => {
        e.preventDefault();
        
        if (!codeInput.value.trim()) {
            showValidationError(codeInput, window.validationMessages?.codeRequired || 'Verification code is required.');
            return;
        }
        
        if (codeInput.value.length !== 4) {
            showValidationError(codeInput, window.validationMessages?.codeMustBe4Digits || 'Code must be 4 digits.');
            return;
        }
        
        toggleButton(true, verifyButton);
        errorElement.textContent = '';
        
        try {
            const formData = new FormData();
            formData.append('phone', currentPhone);
            formData.append('code', codeInput.value);
            Object.entries(additionalData()).forEach(([key, val]) => formData.append(key, val));
            
            const response = await fetch(`${baseUrl}${verifyRoute}`, {
                method: 'POST',
                headers: { 'X-CSRF-TOKEN': csrfToken },
                body: formData
            });
            
            const data = await response.json();
            
            if (!response.ok || !data.status) {
                errorElement.textContent = data.message || 'Verification failed';
                return;
            }
            
            window.location.href = data.redirect || baseUrl;
        } catch (error) {
            console.error('SMS verify error:', error);
            errorElement.textContent = 'A system error occurred. Please try again.';
        } finally {
            toggleButton(false, verifyButton);
        }
    });
    
    // Resend SMS
    resendButton?.addEventListener('click', async (e) => {
        e.preventDefault();
        if (resendButton.disabled) return;
        
        toggleButton(true, resendButton);
        errorElement.textContent = '';
        
        try {
            const formData = new FormData();
            formData.append('phone', currentPhone);
            formData.append('type', type);
            formData.append('lang', appLocale);
            
            const response = await fetch(`${baseUrl}${resendRoute}`, {
                method: 'POST',
                headers: { 'X-CSRF-TOKEN': csrfToken },
                body: formData
            });
            
            const data = await response.json();
            
            if (!response.ok || !data.status) {
                errorElement.textContent = data.message || 'Failed to resend SMS';
                toggleButton(false, resendButton);
                return;
            }
            
            errorElement.textContent = window.validationMessages?.codeResent || 'Code resent successfully!';
            errorElement.style.color = 'green';
            setTimeout(() => {
                errorElement.textContent = '';
                errorElement.style.color = '';
            }, 3000);
            
            toggleButton(false, resendButton);
            if (data.resend_available_at && data.server_time) {
                startCountdown(resendButton.id, data.resend_available_at, data.server_time);
            }
        } catch (error) {
            console.error('SMS resend error:', error);
            errorElement.textContent = 'A system error occurred. Please try again.';
            toggleButton(false, resendButton);
        }
    });
}

// ==========================
// Unified SMS Authentication (Login & Registration)
// ==========================
const smsAuthForm = document.querySelector('#sms-auth-form');
if (smsAuthForm) {
    const countryCodeSelect = document.querySelector('#country-code-select');
    const phoneInput = document.querySelector('#phone-input');
    
    if (phoneInput) {
        console.log('SMS Auth Form Initialized');

        const updatePhoneInputConstraints = () => {
            const code = countryCodeSelect ? countryCodeSelect.value : '+992';
            console.log('Updating constraints for country code:', code);

            phoneInput.placeholder = 'XXXXXXXXX';
            phoneInput.maxLength = 9;
            phoneInput.setAttribute('maxlength', '9');
        };
        
        countryCodeSelect?.addEventListener('change', function() {
            updatePhoneInputConstraints();
            phoneInput.value = ''; 
            clearValidationError(phoneInput);
            phoneInput.focus();
        });
        
        updatePhoneInputConstraints();
        
        phoneInput.addEventListener('input', function(e) {
            let val = this.value.replace(/\D/g, '');
            const maxLen = 9;
            if (val.length > maxLen) {
                val = val.slice(0, maxLen);
            }
            if (this.value !== val) {
                this.value = val;
            }
        });
        
        phoneInput.addEventListener('keypress', function(e) {
            if (!/^\d$/.test(e.key) && !['Backspace', 'Delete', 'Tab', 'ArrowLeft', 'ArrowRight'].includes(e.key)) {
                e.preventDefault();
            }
        });
    }
    
    handleSmsFlow({
        form: smsAuthForm,
        phoneInput: smsAuthForm.querySelector('input[name="phone"]'),
        codeInput: smsAuthForm.querySelector('input[name="code"]'),
        codeSection: document.querySelector('#sms-code-section'),
        sendButton: document.querySelector('#send-sms-button'),
        verifyButton: document.querySelector('#verify-sms-button'),
        resendButton: document.querySelector('#resend-sms-button'),
        errorElement: document.querySelector('#sms_auth_error_message'),
        sendRoute: '/send-auth-sms',
        verifyRoute: '/verify-auth-sms',
        resendRoute: '/resend-auth-sms',
        type: 'auth',
        additionalData: () => {
            const countryCodeSelect = document.querySelector('#country-code-select');
            return {
                country_code: countryCodeSelect ? countryCodeSelect.value : '+992'
            };
        }
    });
}

// ==========================
// Register Form (Email/Password - Hidden)
// ==========================
const registerForm = document.querySelector('#registerForm');
if (registerForm) {
    const registerButton = document.querySelector('#register-button');
    const errorMessage = document.querySelector('#error_message');
    const baseUrl = document.querySelector('meta[name="base-url"]').getAttribute('content');

    const firstNameInput = registerForm.querySelector('input[name="first_name"]');
    const lastNameInput = registerForm.querySelector('input[name="last_name"]');

    [firstNameInput, lastNameInput].forEach(input => {
        input?.addEventListener('input', () => {
            const numberPattern = /[0-9]/g;
            if (numberPattern.test(input.value)) {
                input.value = input.value.replace(numberPattern, '');
                showValidationError(input, 'Name field does not allow numbers.');
            } else if (!input.value.trim()) {
                showValidationError(input, 'This field is required.');
            } else {
                clearValidationError(input);
            }
        });
    });

    attachLiveInputClear(registerForm, ['first_name', 'last_name', 'email', 'password', 'confirm_password']);

    registerForm.addEventListener('submit', async function (e) {
        e.preventDefault();
        if (!validateRegisterForm()) return;

        toggleButton(true, registerButton);
        errorMessage.textContent = '';

        try {
            const formData = new FormData(this);
            const response = await fetch(`${baseUrl}/api/register?is_ajax=1`, {
                method: 'POST',
                headers: {
                    'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
                },
                body: formData
            });

            const data = await response.json();

            if (!response.ok || !data.status) {
                const message = data.errors ? Object.values(data.errors).flat()[0] : data.message || 'An error occurred during registration';
                errorMessage.textContent = message;
                return;
            }

            const loginResponse = await fetch(`${baseUrl}/api/login?is_ajax=1`, {
                method: 'POST',
                headers: {
                    'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
                },
                body: formData
            });

            const loginData = await loginResponse.json();
            if (loginData.status === true) {
                window.location.href = `${baseUrl}`;
            } else {
                errorMessage.textContent = loginData.message || 'Login after registration failed.';
            }

        } catch (error) {
            console.error('Registration error:', error);
            errorMessage.textContent = 'A system error occurred. Please try again later.';
        } finally {
            toggleButton(false, registerButton);
        }
    });

    function validateRegisterForm() {
        let isValid = true;
        const firstName = registerForm.querySelector('input[name="first_name"]');
        const lastName = registerForm.querySelector('input[name="last_name"]');
        const email = registerForm.querySelector('input[name="email"]');
        const password = registerForm.querySelector('input[name="password"]');
        const confirmPassword = registerForm.querySelector('input[name="confirm_password"]');

        if (!firstName.value.trim()) {
            showValidationError(firstName, 'First Name field is required.');
            isValid = false;
        }

        if (!lastName.value.trim()) {
            showValidationError(lastName, 'Last Name field is required.');
            isValid = false;
        }

        if (!email.value.trim()) {
            showValidationError(email, 'Email field is required.');
            isValid = false;
        } else if (!validateEmail(email.value)) {
            showValidationError(email, 'Enter a valid Email Address.');
            isValid = false;
        }

        if (!password.value.trim()) {
            showValidationError(password, 'Password field is required.');
            isValid = false;
        } else if (password.value.length < 8) {
            showValidationError(password, 'Password must be at least 8 characters long.');
            isValid = false;
        }

        if (password.value !== confirmPassword.value) {
            showValidationError(confirmPassword, 'Passwords and confirm password do not match.');
            isValid = false;
        }

        return isValid;
    }
}

// ==========================
// Login Form (Email/Password - Hidden)
// ==========================
const loginForm = document.querySelector('#login-form');
if (loginForm) {
    const loginButton = document.querySelector('#login-button');
    const loginError = document.querySelector('#login_error_message');
    const baseUrl = document.querySelector('meta[name="base-url"]').getAttribute('content');

    attachLiveInputClear(loginForm, ['email', 'password']);

    loginForm.addEventListener('submit', async function (e) {
        e.preventDefault();
        if (!validateLoginForm()) return;

        toggleButton(true, loginButton);
        loginError.textContent = '';

        try {
            const formData = new FormData(this);
            const response = await fetch(`${baseUrl}/api/login?is_ajax=1`, {
                method: 'POST',
                headers: {
                    'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
                },
                body: formData
            });

            const data = await response.json();

            if (!response.ok || !data.status) {
                const message = data.errors ? Object.values(data.errors).flat()[0] : data.message || 'Login failed';
                loginError.textContent = message;
                return;
            }

            if (data.device_limit_reached) {
                loginError.textContent = "Your device limit has been reached.";
                return;
            }

            window.location.href = `${baseUrl}`;
        } catch (error) {
            console.error('Login error:', error);
            loginError.textContent = 'A system error occurred. Please try again later.';
        } finally {
            toggleButton(false, loginButton);
        }
    });

    function validateLoginForm() {
        let isValid = true;
        const email = loginForm.querySelector('input[name="email"]');
        const password = loginForm.querySelector('input[name="password"]');

        if (!email.value.trim()) {
            showValidationError(email, 'Email field is required.');
            isValid = false;
        } else if (!validateEmail(email.value)) {
            showValidationError(email, 'Enter a valid Email Address.');
            isValid = false;
        }

        if (!password.value.trim()) {
            showValidationError(password, 'Password field is required.');
            isValid = false;
        }

        return isValid;
    }
}

// ==========================
// Forgot Password Form
// ==========================
const forgetPasswordForm = document.querySelector('#forgetpassword-form');
if (forgetPasswordForm) {
    const forgetPasswordButton = document.querySelector('#forget_password_btn');
    const forgetPasswordError = document.querySelector('#forgetpassword_error_message');
    const forgetPasswordMessage = document.querySelector('#forget_password_msg');
    const baseUrl = document.querySelector('meta[name="base-url"]').getAttribute('content');

    attachLiveInputClear(forgetPasswordForm, ['email']);

    forgetPasswordForm.addEventListener('submit', async function (e) {
        e.preventDefault();
        if (!validateForgetPasswordForm()) return;

        toggleButton(true, forgetPasswordButton);
        forgetPasswordError.textContent = '';
        forgetPasswordMessage.classList.add('d-none');

        try {
            const formData = new FormData(this);
            const response = await fetch(`${baseUrl}/api/forgot-password?is_ajax=1`, {
                method: 'POST',
                headers: {
                    'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
                },
                body: formData
            });

            const data = await response.json();

            if (!response.ok || !data.status) {
                const message = data.errors ? Object.values(data.errors).flat()[0] : data.message || 'Password reset failed';
                forgetPasswordError.textContent = message;
                return;
            }

            forgetPasswordMessage.classList.remove('d-none');
            forgetPasswordForm.reset();
        } catch (error) {
            console.error('Forgot password error:', error);
            forgetPasswordError.textContent = 'A system error occurred. Please try again later.';
        } finally {
            toggleButton(false, forgetPasswordButton);
        }
    });

    function validateForgetPasswordForm() {
        let isValid = true;
        const email = forgetPasswordForm.querySelector('input[name="email"]');

        if (!email.value.trim()) {
            showValidationError(email, 'Email field is required.');
            isValid = false;
        } else if (!validateEmail(email.value)) {
            showValidationError(email, 'Enter a valid Email Address.');
            isValid = false;
        }

        return isValid;
    }
}

